import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { TranslateService } from '@ngstack/translate';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect } from '@angular/material';
import { SoundEnum } from 'src/app/enums/sound.enum';
import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { IBranch } from 'src/app/interfaces/branch';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { SettingService } from 'src/app/services/http/business/setting/setting.service';
import { SubsidiaryMemorandumService } from 'src/app/services/http/business/subsidiary/subsidiary-memorandum.service';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { CustomValidators } from 'src/app/shared/customValidators';
import { SubsidiaryCompanyAgentService } from 'src/app/services/http/business/subsidiary/subsidiary-company-agent.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-subsidiary-memorandum-entry',
  templateUrl: './subsidiary-memorandum-entry.component.html',
  styleUrls: ['./subsidiary-memorandum-entry.component.css']
})
export class SubsidiaryMemorandumEntryComponent implements OnInit {
  form: FormGroup;
  customers = [];
  WeekDays = [];
  branchList: IBranch;
  errors = new Array();
  errObject: any;
  customerAgents: any;
  eduPackageList: IEducationPackage;
  param: string[];
  errorList: IError[] = [];
  customer: any;
  showSearch: boolean = true;
  contractNumber: any;
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private eduPackageService: EducationPackageService,
    public translate: TranslateService,
    private settingService: SettingService,
    private staticValueService: StaticValueService,
    private subsidiaryCompanyAgentService: SubsidiaryCompanyAgentService,
    private branchService: BranchService,
    private subsidiaryMemorandumService: SubsidiaryMemorandumService,
    private subsidiaryCompanyService: SubsidiaryCompanyService,
    private dialogRef: MatDialogRef<SubsidiaryMemorandumEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.formControl();
    this.getWeekDays(false);

    if (this.data && this.data.Id) {
      this.setDataBranchsAndPackages(
        this.data.CustomerContractBranchDataList, this.data.CustomerContractPackageDataList
      );
    }
    this.setContractNumber();
    this.getBranchList();
    this.getEduPackage();
    if (this.data.CustomerId) {
      this.showSearch = false;
      this.getContractById();
    } else
      this.getCustomerList();
    this.getCustomerAgent();
  }

  formControl() {
    this.form = this.fb.group({
      Id: [this.data && this.data["Id"] ? this.data["Id"] : 0],
      Title: [
        this.data && this.data["Title"] ? this.data["Title"] : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.minLength(2)
        ])
      ],

      DiscountFree: [
        this.data && this.data["DiscountFree"] ?
          this.data["DiscountFree"].toString()
          : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(100)
        ])
      ],

      DiscountPayable: [
        this.data && this.data["DiscountPayable"] ?
          this.data["DiscountPayable"].toString()
          : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(100)
        ])
      ],

      ContractNumber: [
        this.data && this.data["ContractNumber"]
          ? this.data["ContractNumber"]
          : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(90)
        ])
      ],

      ContractNumberAttachment: [
        this.data && this.data["ContractNumberAttachment"]
          ? this.data["ContractNumberAttachment"].toString()
          : null,
        Validators.compose([
          Validators.minLength(0),
          Validators.maxLength(50)
        ])
      ],

      CustomerAgentId: [null,
        Validators.compose([
          Validators.required
        ])
      ],

      ContractDate: [
        this.data && this.data["ContractDate"] ?
          this.data["ContractDate"] : null,
        Validators.compose([
          Validators.required
        ])
      ],
      StartDate: [
        this.data && this.data["StartDate"] ?
          this.data["StartDate"] : null,
        Validators.compose([
          Validators.required
        ])
      ],
      EndDate: [
        this.data && this.data["EndDate"] ?
          this.data["EndDate"] : null,
        Validators.compose([
          Validators.required
        ])
      ],

      BranchsEncryptId: [new Array()],

      EducationPackagesId: [new Array()],

      Explain: [
        this.data && this.data["Explain"]
          ? this.data["Explain"].toString()
          : null
      ],

      weekDays: this.fb.array([])

    });
    if (this.data.CustomerAgentId)
      this.form.controls['CustomerAgentId'].patchValue(this.data.CustomerAgentId.toString());
  }

  createFormWeekDays(items: any): void {

    const creds = this.form.controls.weekDays as FormArray;
    items.forEach((element) => {
      creds.push(
        this.fb.group({
          WeekDayId: new FormControl(element["Value"]),
          isActive: new FormControl(element.Selected),
          WeekDayName: new FormControl(element.Text),
          StartTime: new FormControl(null),
          EndTime: new FormControl(null)
        },
          { validator: CustomValidators.activeValidatorsWeekDays })
      );
    });

    // set value with data update
    if (this.data && this.data.CustomerContractTimeDataList) {
      //update data
      this.editFormWeekDays(creds, this.data.CustomerContractTimeDataList);

    }

  }

  setDataBranchsAndPackages(branchDataList: any, packageDataList: any): void {
    let BranchsEncryptId = [];
    let EducationPackageId = [];
    branchDataList.forEach(x => {
      BranchsEncryptId.push(x.BranchEncryptId);
      this.form["controls"]["BranchsEncryptId"].setValue(BranchsEncryptId);
    });

    //EducationPackageId
    packageDataList.forEach(x => {
      EducationPackageId.push(x.EducationPackageId);
      this.form["controls"]["EducationPackagesId"].setValue(EducationPackageId);
    });
  }
  // set value in weekDaysForm with data updateed
  editFormWeekDays(weekDaysForm: any, array: any): void {
    weekDaysForm.controls.forEach(element => {
      let day = array.find(day => day.WeekDayId == element.value["WeekDayId"]);
      if (day) {
        element["controls"]["isActive"].setValue(true);
        element["controls"]["StartTime"].setValue(day.StartTime);
        element["controls"]["EndTime"].setValue(day.EndTime);
      }
    });
  }

  getCustomerList() {
    this.subsidiaryCompanyService.getCustomerListCombo().subscribe(res => {
      this.customers = res;
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }

  setFilter(event: MatSelect) {
    this.data = {
      CustomerId: event.value
    }
    this.showSearch = false;
    this.getContractById();
  }

  getContractById() {
    let queryParams = {
      Id: this.data.CustomerId
    };
    this.subsidiaryCompanyService.getCustomerList(queryParams).subscribe(
      res => {

        this.customer = res.DataList[0];
      }
    );
  }

  getBranchList() {
    this.branchService.list(true).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCustomerAgent() {
    let queryParams = {
      CustomerId: this.data.CustomerId
    };
    this.subsidiaryCompanyAgentService.getCustomerAgentList(queryParams).subscribe(
      res => {
        this.customerAgents = res.DataList;
      }
    );
  }

  getWeekDays(value: boolean) {
    this.staticValueService.getWeekDays(value).subscribe(
      res => {
        this.WeekDays = res;
        this.createFormWeekDays(this.WeekDays);
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setContractNumber() {
    this.settingService.getIndicator().subscribe(
      res => {
        this.contractNumber = res.IndicatoNumber;
        this.form.controls["ContractNumber"].patchValue(res.IndicatoNumber);
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  submit(form: any) {

    this.errors = new Array();
    if (form.ContractDate && form.StartDate) {
      form.ContractDate = moment
        .from(form.ContractDate, "en")
        .utc(true)
        .format(environment.dateFormat);

      form.StartDate = moment
        .from(form.StartDate, "en")
        .utc(true)
        .format(environment.dateFormat);

      form.EndDate = moment
        .from(form.EndDate, "en")
        .utc(true)
        .format(environment.dateFormat);
    }

    const command: any = {
      "CustomerId": this.data.CustomerId,
      "ContractNumber": form.ContractNumber,
      "Id": form.Id,
      "Title": form.Title,
      "ContractDate": form.ContractDate,
      "ContractNumberAttachment": form.ContractNumberAttachment,
      "StartDate": form.StartDate,
      "EndDate": form.EndDate,
      "CustomerAgentId": form.CustomerAgentId,
      "DiscountFree": form.DiscountFree,
      "DiscountPayable": form.DiscountPayable,
      "Explain": form.Explain,
      "CustomerContractBranchDataList": [],
      "CustomerContractPackageDataList": [],
      "CustomerContractTimeDataList": []
    }

    form.BranchsEncryptId.forEach(x => {
      command.CustomerContractBranchDataList.push({ BranchEncryptId: x });
    });

    form.EducationPackagesId.forEach(x => {
      command.CustomerContractPackageDataList.push({ EducationPackageId: x });
    });

    form.weekDays.forEach(x => {
      if (x.isActive && x.StartTime && x.EndTime) {
        command.CustomerContractTimeDataList.push(x);
      }
    });

    if (this.data && this.data.Id) {
      this.subsidiaryMemorandumService.understandingEdit(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    } else {
      this.subsidiaryMemorandumService.understandingAdd(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}

